// extracted by mini-css-extract-plugin
module.exports = {"QRScanner":"QRScanner_QRScanner__1FinC"};